// Fallback: если Socket.IO *:ready пропущен (reconnect gap), поллим status
// placeholder-сущности и переводим artifact_card pending → ready/failed.

import { trpcQuery } from "@/lib/trpc-fetch";
import type { CreateFromChatArtifact } from "./create-from-chat-options-dialog";

export type ArtifactTerminalStatus = {
	status: "ready" | "failed";
	summary?: string;
};

export interface ReconcilePending {
	artifact: CreateFromChatArtifact;
	jobRef: string;
	materialId: string;
}

/**
 * Читает terminal-статус placeholder (quiz/notes/flashcards).
 * Glossary — без отдельной entity-строки; остаётся на socket.
 */
export async function fetchCreateFromChatTerminal(
	pending: ReconcilePending,
): Promise<ArtifactTerminalStatus | null> {
	try {
		switch (pending.artifact) {
			case "quiz": {
				const res = await trpcQuery<{
					quiz: { generationStatus: string; questionsCount?: number };
				}>("quizzes.get", { id: pending.jobRef, includeQuestions: false });
				const st = res.quiz.generationStatus;
				if (st === "ready") {
					return {
						status: "ready",
						...(typeof res.quiz.questionsCount === "number"
							? { summary: String(res.quiz.questionsCount) }
							: {}),
					};
				}
				if (st === "failed") return { status: "failed" };
				return null;
			}
			case "notes": {
				const res = await trpcQuery<{
					note: { generationStatus: string };
				}>("notes.get", { id: pending.jobRef });
				const st = res.note.generationStatus;
				if (st === "ready") return { status: "ready" };
				if (st === "failed") return { status: "failed" };
				return null;
			}
			case "flashcards": {
				// Namespace — flashcardSets.*, не flashcards.* (там карточка по id).
				const res = await trpcQuery<{
					set: { processingStatus: string; cardCount?: number };
				}>("flashcardSets.get", { id: pending.jobRef });
				const st = res.set.processingStatus;
				if (st === "ready") {
					return {
						status: "ready",
						...(typeof res.set.cardCount === "number"
							? { summary: String(res.set.cardCount) }
							: {}),
					};
				}
				if (st === "failed") return { status: "failed" };
				return null;
			}
			case "glossary":
				return null;
		}
	} catch {
		return null;
	}
}
